import { render, staticRenderFns } from "./CustomerSelectionDialog.vue?vue&type=template&id=313b7367&scoped=true"
import script from "./CustomerSelectionDialog.vue?vue&type=script&lang=js"
export * from "./CustomerSelectionDialog.vue?vue&type=script&lang=js"
import style0 from "./CustomerSelectionDialog.vue?vue&type=style&index=0&id=313b7367&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313b7367",
  null
  
)

export default component.exports